import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  TranslateDirective,
  TranslatePipe,
  provideTranslateService,
} from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";

// ngx-translate v18 no longer ships an NgModule: the pipe and directive are
// standalone and everything else is wired up through providers. This module
// keeps that behind the same I18nModule the NgModules of this app already
// import.
@NgModule({
  imports: [CommonModule, TranslatePipe, TranslateDirective],
  exports: [TranslatePipe, TranslateDirective],
  providers: [
    provideTranslateService({
      lang: "de",
      fallbackLang: "de",
      loader: provideTranslateHttpLoader({
        prefix: "/assets/i18n/",
        suffix: ".json",
      }),
    }),
  ],
})
export class I18nModule {}
